import type { Recipe } from '../types';

/** After this long, a pending recipe is treated as stuck and unlocked without AI. */
export const STALE_PENDING_RECIPE_MS = 30 * 60 * 1000;

export function isRecipeSavePending(recipe: Pick<Recipe, 'saveStatus'> | null | undefined): boolean {
    return recipe?.saveStatus === 'pending';
}

export function isStalePendingRecipe(
    recipe: Pick<Recipe, 'saveStatus' | 'updatedAt' | 'createdAt'>,
): boolean {
    if (!isRecipeSavePending(recipe)) return false;
    const timestamp = recipe.updatedAt || recipe.createdAt;
    const updatedAtMs = timestamp ? Date.parse(timestamp) : Number.NaN;
    if (!Number.isFinite(updatedAtMs)) return true;
    return Date.now() - updatedAtMs >= STALE_PENDING_RECIPE_MS;
}
